import { Link, useSearchParams } from "react-router-dom"
import Chart from 'react-google-charts'
import { callDashboardViewGet } from "../actions/dashboard";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { useEffect } from "react";
import moment from "moment"

let Dashboard = ({ regions = [], dateCheck = '', methods: { callDashboardViewGet } }) => {
    let [searchParams] = useSearchParams();

    useEffect(() => {
        callDashboardViewGet()
    }, [callDashboardViewGet, searchParams])

    return (
        <div className="container-fluid mt-4">
            <div className="card">
                <div className="card-body">
                    <div className="d-flex justify-content-between">
                        <div>
                            <h2 className="card-title">Dashboard</h2>
                            <p className="card-text">Informações do ultimo turno verificado na data: <b>{dateCheck ? moment(dateCheck.replace(/T/igm, ' ').replace(/Z/igm, '')).format("DD/MM/YYYY HH:mm") : 'não iniciado'}</b></p>
                        </div>
                    </div>
                    <ul className="nav nav-tabs mt-4">
                        <li className="nav-item">
                            <Link className='nav-link active' to='/'>Informações</Link>
                        </li>
                    </ul>
                    <div className="tabcontent-border">
                        <div className="row">
                            {regions.map((a, ai) => {
                                var data = [
                                    ['Status', 'Qtde'],
                                    ['Ativo', a.actives],
                                    ['Inativo', a.inactives],
                                    ['Pendentes', a.total],
                                ];

                                var options = {
                                    title: 'Região: ' + a.name,
                                    chartArea: { width: "50%" },
                                    colors: ["#009900", "#990000", "#000099"],
                                    is3D: true,
                                };

                                return (
                                    <div key={ai} className='col-md-6'>
                                        <Chart
                                            chartType="PieChart"
                                            width="100%"
                                            height="400px"
                                            data={data}
                                            options={options}
                                        />
                                    </div>
                                )
                            })}

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = ({ dashboard: { regions, dateCheck } }) => ({
    regions: regions,
    dateCheck: dateCheck,
});

const mapDispatchToProps = (dispatch) => ({
    methods: bindActionCreators(
        {
            callDashboardViewGet,
        },
        dispatch
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)